import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';

export const Header = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      css={({ theme }) => ({ gap: theme.space['8'] })}
      maxWidth="600px"
    >
      <Text as="h2" fontWeight={600} color="neutral.700" fontSize="h4">
        Personal Finance Templates
      </Text>

      <Text color="neutral.500">
        Create and save customized Personal Finance Templates. Once a template is created, it can be
        assigned at various levels within the Client Experience App in Orion Connect.
      </Text>
    </Box>
  );
};
